import { render, staticRenderFns } from "./myHeader.vue?vue&type=template&id=03601988&scoped=true"
import script from "./myHeader.vue?vue&type=script&lang=js"
export * from "./myHeader.vue?vue&type=script&lang=js"
import style0 from "./myHeader.vue?vue&type=style&index=0&id=03601988&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03601988",
  null
  
)

export default component.exports